<template>
    <div class="logsContainer">
        <!-- 条件 -->
        <el-row>
            <el-form label-width="100px" ref="form" :model="form">
            <el-col :span="6">
                <el-form-item label="项目名称">
                    <el-input v-model="form.project"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="主机IP">
                    <el-input v-model="form.host_ip"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="模块类型" :rules="{required: true, message: '必填项'}" prop="moduleType">
                    <el-input v-model="form.moduleType"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="查询关键词">
                    <el-input v-model="form.keyword" @input="highLightWord"></el-input>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
                <el-form-item label="上下文(条)">
                    <el-input v-model="form.keywordNum"></el-input>
                </el-form-item>
            </el-col> -->
            <el-col :span="6">
                <el-form-item label="日志级别">
                    <el-input v-model="form.level"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="10">
                <el-form-item label="时间" :rules="{required: true, message: '必填项'}" prop="time">
                    <el-date-picker
                        v-model="form.time"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="2">
            <el-button type="primary" @click="search">查询</el-button>
            </el-col>
            </el-form>
        </el-row>
        <!-- 数据列表 -->
        <el-table
            :data="lists"
            @cell-dblclick="cellClick"
        >
            <el-table-column align="center" prop="project" label="项目名称" show-overflow-tooltip width="100"></el-table-column>
            <el-table-column align="center" prop="modulesType" label="模块名称" width="100"></el-table-column>
            <el-table-column align="center" prop="hostIp" label="主机ip" width="120"></el-table-column>
            <el-table-column align="center" prop="fulldatetime" label="日志时间" width="200"></el-table-column>
            <el-table-column prop="data" label="日志内容">
                <template slot-scope="scope">
                    <div v-html="scope.row.data"></div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="fy"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40]"
            :page-size="pageSize"
            :total="totalElement"
            layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>

        <!-- <el-dialog :title="`模块：${currentData.modulesType}，项目：${currentData.project}`"
            v-if="showDataDetail"
            :visible="showDataDetail"
            @close="showDataDetail = false"
            width="90%"
        >
            <div v-html="currentData.context"></div>

            <div style="margin-top: 20px;text-align: center;">
                <el-button @click="showDataDetail = false">关闭</el-button>
            </div>
        </el-dialog> -->
        <logs-detail v-if="showDataDetail"
            :visible="showDataDetail"
            :log="currentData"
            @closeLog="showDataDetail = false">

        </logs-detail>
    </div>
</template>
<script>
import { Loading } from "element-ui";
import ModuleListVue from '../instance/ModuleList.vue';
import LogsDetail from './LogsDetail'
export default {
    components: { LogsDetail },
    data: vm=>({
        form:{
            project: '',
            level: '',
            moduleType: '',
            host_ip: '',
            keyword: '',
            startTime: '',
            endTime: '',
            time: '',
            keywordNum: 5,
        },
        time: ['',''],
        pickerOptions: {
            shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近一个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近三个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                }
            }]
        },
        lists: [],
        currentPage: 1,
        pageSize: 10,
        totalElement: 0,
        showDataDetail: false,
        currentData: {}, //当前选中的行
        oldLists: []
    }),
    methods: {
        cellClick(row, column, event){
            this.currentData = row
            if(column.label == '日志内容'){
                this.showDataDetail = true
            }
        },
        handleSizeChange(val){
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.getList()
        },
        search(){
            this.$refs.form.validate(valid => {
                if(valid){
                    this.getList()
                }else{
                    this.$message.warning('请填写必填项')
                }
            })
        },
        getList(){
            let arg = this.form
            arg.startTime = this.form.time[0]
            arg.endTime = this.form.time[1]
            arg.pageSize = this.pageSize
            arg.page = this.currentPage

            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios.post(this.baseUrl3 +'log/es/search',
                arg)
                .then(({ data: { code, msg, data } }) => {
                    loading.close();
                    if(code != 20000){
                        this.$message.error(msg);
                        return
                    }

                    // 将字符串中的回车符替换成页面能识别的换行符
                    // data.list.forEach(item => {
                    //     item.context = item.context ? item.context.replace(/\n/g, "<br/>") : ''
                    // })
                    this.oldLists = Array.from(data.list)
                    this.lists = data.list
                    this.totalElement = data.total
                    this.highLightWord(this.form.keyword)
                })
                .catch(err => {
                    loading.close();
                    console.log(err)
                })
        },
        highLightWord(val){
            // if(val){
                this.lists = JSON.parse(JSON.stringify(this.oldLists))
                this.lists.forEach(item => {
                    if (val) {
                        if (item.data) {
                            const datastr = item.data.split(val)
                            item.data = datastr.join('<span style="background-color: gold;">' + val + '</span>')
                        }

                        // if (item.context) {
                        //     const datastr = item.context.split(val)
                        //     item.context = datastr.join('<span style="background-color: gold;">' + val + '</span>')
                        // }
                    }
                })
            // }
        }
    }
}
</script>
<style scoped>
.logsContainer >>> .el-form-item{
    width: 90%;
}

</style>
